@if (isVisible()) {
  <div [ngClass]="'alert alert--' + variant()">
    <div class="alert__icon">
      <htx-icon [icon]="getIcon()"></htx-icon>
    </div>

    <div class="alert__content">
      @if (title()) {
        <div class="alert__title">{{ title() }}</div>
      }
      <div class="alert__message">
        {{ message() }}
      </div>
    </div>

    @if (closable()) {
      <button class="alert__close" (click)="onClose()" type="button" aria-label="Close alert">
        <htx-icon [icon]="'close'"></htx-icon>
      </button>
    }
  </div>
}
